import React from "react"
import { Zap } from "lucide-react"
import { useLang } from "./i18n/LangContext"

export function SiteFooter() {
  const { t } = useLang()

  return (
    <footer className="bg-white dark:bg-gray-950 border-t border-gray-200 dark:border-gray-800 py-10">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-sm font-semibold text-gray-900 dark:text-white">
          <Zap className="h-4 w-4 text-indigo-600 dark:text-indigo-400" />
          Appdesh
        </div>
        <p className="text-xs text-gray-400 dark:text-gray-500">
          &copy; {new Date().getFullYear()} Revnous. {t.footer.rights}
        </p>
        <a
          href="/impressum"
          className="text-xs text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
        >
          {t.footer.legal}
        </a>
      </div>
    </footer>
  )
}
